import styled from "styled-components";
import { UnorderedListStyle, BulletListItemStyle } from "./PageLists";

export const TextEditor = styled.div`
  p {
    margin-bottom: 16px;
  }

  ul {
    ${UnorderedListStyle}
    margin-bottom: 16px;

    li {
      ${BulletListItemStyle}

      p {
        line-height: 22px;
        margin: 0;
      }

      ul {
        padding-top: 16px;
      }
    }
  }

  ol {
    margin-left: 20px;

    li {
      line-height: 22px;
      margin-bottom: 16px;

      p {
        line-height: 30px;
        margin: 0;
      }
    }
  }
`;
